/** @format */

export const pascalCaseToLabel = (str: string): string =>
  str
    .replace(/([A-Z])/g, " $1")
    .charAt(0)
    .toUpperCase() + str.replace(/([A-Z])/g, " $1").slice(1);
